import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const successLookup = (response) => {
  store.dispatch('getURLLookup', response.data);
  // Vue.router.push({
  //   name: 'home.index',
  // });
  // return lookupResponse.data;
};

// When the request fails
const failedLookup = () => {
};

export default (urltoquery, spid) => {
  const axiosOptions = {
    timeout: 5000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  const queryinfo = {
    url: urltoquery,
  };
  const thisurl = `/api/v1/sp/${spid}/lookup-url`;
  Vue.$http.post(thisurl, queryinfo, axiosOptions)
   .then((response) => {
     successLookup(response);
   })
   .catch((error) => {
     failedLookup(error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/list/lookupspurl.js